import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get("next") || "/";
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const res = await register(form.email, form.password, form.name);
    setLoading(false);
    if (!res.ok) { setError(res.error); return; }
    toast.success(`Welcome to the boutique, ${res.user.name}!`);
    navigate(redirectTo);
  };

  return (
    <div data-testid="register-page" className="max-w-md mx-auto px-6 py-16 sm:py-24">
      <div className="font-script text-3xl text-[#e8478e]">Join The Babes</div>
      <h1 className="font-display text-4xl sm:text-5xl font-black text-[#1c1815] tracking-tight">Sign Up</h1>

      <form onSubmit={submit} className="mt-8 space-y-4 p-7 sm:p-8 rounded-3xl border border-[#e5dccd] bg-white shadow-sm">
        <div>
          <label className="text-[10px] uppercase tracking-[0.25em] text-[#8a8076] font-bold">Name</label>
          <input required data-testid="register-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}
            className="mt-1.5 w-full bg-[#faf4e9] border border-[#e5dccd] focus:border-[#2eb6a8] focus:ring-2 focus:ring-[#2eb6a8]/20 rounded-xl px-4 py-3 outline-none text-[#1c1815]"/>
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.25em] text-[#8a8076] font-bold">Email</label>
          <input type="email" required data-testid="register-email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            className="mt-1.5 w-full bg-[#faf4e9] border border-[#e5dccd] focus:border-[#2eb6a8] focus:ring-2 focus:ring-[#2eb6a8]/20 rounded-xl px-4 py-3 outline-none text-[#1c1815]"/>
        </div>
        <div>
          <label className="text-[10px] uppercase tracking-[0.25em] text-[#8a8076] font-bold">Password</label>
          <input type="password" required minLength={6} data-testid="register-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })}
            className="mt-1.5 w-full bg-[#faf4e9] border border-[#e5dccd] focus:border-[#2eb6a8] focus:ring-2 focus:ring-[#2eb6a8]/20 rounded-xl px-4 py-3 outline-none text-[#1c1815]"/>
          <div className="text-[10px] uppercase tracking-[0.2em] text-[#8a8076] mt-1.5">Min 6 characters</div>
        </div>
        {error && <div data-testid="register-error" className="text-[#c93875] text-sm">{error}</div>}
        <button type="submit" disabled={loading} data-testid="register-submit"
          className="w-full bg-[#e8478e] hover:bg-[#c93875] hover:shadow-lg hover:-translate-y-0.5 text-white font-bold uppercase tracking-[0.2em] text-xs py-3.5 rounded-full transition-all disabled:opacity-60">
          {loading ? "Creating…" : "Create Account"}
        </button>
        <p className="text-center text-sm text-[#8a8076]">
          Already have an account? <Link to="/login" className="text-[#2eb6a8] font-bold hover:text-[#1f8d83]">Log in</Link>
        </p>
      </form>
    </div>
  );
}
